import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type TNavigationMenuContentElement,
  type TNavigationMenuContentProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuContent = forwardRef<
  TNavigationMenuContentElement,
  TNavigationMenuContentProps
>(({ className, ...props }, ref) => (
  <NavigationMenuPrimitive.Content
    ref={ref}
    data-component="NavigationMenuContent"
    className={cn(
      "p-2",
      "left-0 top-0 w-full md:absolute md:w-auto",
      "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out",
      "data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out",
      "data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52",
      "data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52",
      className,
    )}
    {...props}
  />
));

NavigationMenuContent.displayName = NavigationMenuPrimitive.Content.displayName;
